import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Archive, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';

/**
 * Archive Confirmation Modal
 */
const ArchiveModal = ({
  isOpen,
  onClose,
  archiveReason,
  onReasonChange,
  onConfirm,
  actionInProgress
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-xl shadow-xl w-full max-w-sm p-6"
          >
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Arkiver e-post</h3>
            <p className="text-sm text-gray-600 mb-4">
              Denne e-posten vil flyttes ut av &quot;Nye&quot; og merkes som ikke relevant.
            </p>
            <select
              value={archiveReason}
              onChange={(e) => onReasonChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg mb-4 text-sm"
            >
              <option value="">Velg grunn (valgfritt)</option>
              <option value="spam">Spam / reklame</option>
              <option value="duplicate">Duplikat</option>
              <option value="not_relevant">Ikke relevant</option>
              <option value="handled_elsewhere">Håndtert annet sted</option>
            </select>
            <div className="flex gap-2">
              <Button 
                variant="outline" 
                className="flex-1"
                onClick={onClose}
              >
                Avbryt
              </Button>
              <Button 
                className="flex-1 bg-gray-700 hover:bg-gray-800"
                onClick={onConfirm}
                disabled={actionInProgress === 'archive'}
              >
                {actionInProgress === 'archive' ? (
                  <Loader2 className="w-4 h-4 animate-spin mr-1" />
                ) : (
                  <Archive className="w-4 h-4 mr-1" />
                )}
                Arkiver
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ArchiveModal;
